import { render } from "./ExamStudentAnswerItemComponent.vue?vue&type=template&id=3c9c8892&scoped=true"
import script from "./ExamStudentAnswerItemComponent.vue?vue&type=script&lang=js"
export * from "./ExamStudentAnswerItemComponent.vue?vue&type=script&lang=js"

import "./ExamStudentAnswerItemComponent.vue?vue&type=style&index=0&id=3c9c8892&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9c8892"]])

export default __exports__